export { default } from './CustomCodeConsentContent';
